export default "__VITE_ASSET__DIoq4bWd__"